import { H2 } from '@/components/heading'
import { Section } from '@/components/section'
import { attr, Empty, html, prop, TNode, Value, When } from '@tempots/dom'
import { PlanCard, PlanCardData } from './plan-card'
import { SegmentedInput } from '@tempots/beatui'
import { Track } from '@/services/track'

export type PricingSectionOptions = {
  title?: TNode
  subtitle?: TNode
  plans: PlanCardData[]
  sideContent?: TNode
  displayMonthlyToggle?: Value<boolean>
}

export function PricingSection({
  title = 'Simple, Transparent Pricing',
  subtitle,
  plans,
  sideContent,
  displayMonthlyToggle = true,
}: PricingSectionOptions) {
  const isMonthly = prop(false)

  const defaultSubtitle = html.p(
    attr.class('text-center text-lg text-gray-600'),
    'Choose the plan that fits your needs.',
    html.br(),
    'Scale up or down anytime.'
  )

  return Section(
    { background: 'light' },
    attr.id('pricing'),
    H2(title),
    subtitle ?? defaultSubtitle,
    // Billing toggle
    When(displayMonthlyToggle, () =>
      html.div(
        attr.class(
          'flex justify-center sm:justify-end items-center gap-3 mt-4 sm:mt-0 mb-4 sm:mb-6'
        ),
        SegmentedInput({
          size: 'sm',
          options: {
            monthly: 'Monthly',
            annual: 'Annual',
          },
          value: isMonthly.map(v => (v ? 'monthly' : 'annual')),
          onChange: v => {
            isMonthly.set(v === 'monthly')
            Track.click({
              section: 'pricing',
              element_type: 'button',
              click_action: 'toggle',
              element_id: 'billing_period',
            })
          },
        })
      )
    ),
    // Plans grid - responsive layout
    html.div(
      attr.class('flex flex-col sm:flex-row gap-4 sm:gap-6'),
      html.div(
        attr.class(
          'flex-1 flex flex-col sm:flex-row flex-wrap lg:flex-nowrap items-stretch gap-4 sm:gap-6 p-2 sm:p-4'
        ),
        attr.class(sideContent != null ? 'justify-end' : 'justify-center'),
        ...plans.map(plan => PlanCard({ ...plan, isMonthly }))
      ),
      sideContent != null
        ? html.div(attr.class('flex-1  sm:w-1/3'), sideContent)
        : Empty
    )
  )
}
